import { signal } from '@preact/signals';

/**
 * Set when the customer tries to advance with an invalid down payment. Reset on entering
 * each product's payment step, so an error revealed on one plan doesn't greet them on the
 * next.
 */
export const showPaymentErrors = signal(false);

/** Signals are module-level, so a remount would otherwise inherit revealed errors. */
export function resetPaymentForm(): void {
  showPaymentErrors.value = false;
}
